var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "el-card",
        { staticClass: "card-container just" },
        [
          _c("h3", [_vm._v("Resposta")]),
          _c(
            "el-card",
            [
              _c(
                "validation-observer",
                { ref: "validation" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
                        _c(
                          "p",
                          { staticClass: "titulo" },
                          [
                            _vm._v("Despacho:"),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content:
                                    "Digite @ e o número de uma solicitação para referenciá-la no texto",
                                  placement: "right-end"
                                }
                              },
                              [_c("i", { staticClass: "fa fa-info-circle" })]
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-despacho" },
                          [
                            _c("validation-provider", {
                              attrs: { rules: "required" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-text-editor", {
                                        class: { erro: errors.length },
                                        attrs: { textEditable: true },
                                        model: {
                                          value: _vm.textoDespacho,
                                          callback: function($$v) {
                                            _vm.textoDespacho = $$v
                                          },
                                          expression: "textoDespacho"
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.buscando,
                                              expression: "buscando"
                                            }
                                          ],
                                          staticClass: "box-flutuante"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "box-color" },
                                            _vm._l(
                                              _vm.solicitacoesComplete,
                                              function(s) {
                                                return _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-box-color",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.selecionaSolicitacao(
                                                          s
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(s.numero))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      ),
                                      _c("p", { staticClass: "help-erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]),
                      _c("el-col", { attrs: { lg: 24, md: 24, sm: 24 } }, [
                        _c("p", { staticClass: "titulo" }, [_vm._v("Anexos:")]),
                        _c(
                          "div",
                          [
                            _c("validation-provider", {
                              attrs: { rules: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-anexo", {
                                        attrs: {
                                          id: "upload-anexo",
                                          tiposArquivosPermitidos:
                                            ".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx",
                                          showAnexar: true,
                                          files: _vm.mensagem.anexoCartorios,
                                          errors: errors
                                        },
                                        on: {
                                          uploadFile: _vm.uploadMapa,
                                          removeFile: _vm.removeMapa,
                                          downloadDocumentoCadastro:
                                            _vm.getDownload
                                        },
                                        model: {
                                          value: _vm.mensagem.anexoCartorios,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.mensagem,
                                              "anexoCartorios",
                                              $$v
                                            )
                                          },
                                          expression: "mensagem.anexoCartorios"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "container-buttons",
              attrs: { lg: 24, md: 24, sm: 24 }
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-danger",
                  on: {
                    click: function($event) {
                      return _vm.cancelar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", { staticClass: "btn-nova-solicitacao" }, [
                    _vm._v("Cancelar")
                  ])
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn-success",
                  on: {
                    click: function($event) {
                      return _vm.enviar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-paper-plane" }),
                  _c("span", { staticClass: "btn-nova-solicitacao" }, [
                    _vm._v("Enviar")
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7330229c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7330229c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/ResponderMensagem.vue
// module id = null
// module chunks = 